type Props = {
  className?: string;
};

export const ChatFinecoCopiedIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99503 10.4145C4.8992 10.4145 4.80455 10.3934 4.71773 10.3529C4.63091 10.3123 4.55404 10.2532 4.49253 10.1797L1.55178 6.66749C1.44339 6.53373 1.39191 6.36273 1.40843 6.19136C1.42495 6.01999 1.50815 5.86198 1.64009 5.75139C1.77203 5.64079 1.94215 5.58648 2.11377 5.60015C2.28539 5.61383 2.44476 5.6944 2.55753 5.82449L4.93128 8.66024L9.38253 1.89749C9.42807 1.82159 9.48848 1.75568 9.56015 1.70374C9.63182 1.6518 9.71326 1.61489 9.79956 1.59524C9.88586 1.57559 9.97525 1.57359 10.0623 1.58938C10.1494 1.60517 10.2324 1.63842 10.3063 1.68712C10.3803 1.73582 10.4435 1.79897 10.4924 1.87276C10.5413 1.94656 10.5747 2.02948 10.5907 2.11654C10.6067 2.20359 10.6049 2.29298 10.5855 2.37933C10.566 2.46568 10.5293 2.5472 10.4775 2.61899L5.54253 10.119C5.48632 10.2044 5.41095 10.2755 5.32241 10.3267C5.23387 10.3779 5.13461 10.4077 5.03253 10.4137L4.99503 10.4145Z"
        fill="currentColor"
      />
    </svg>
  );
};
